<template>
    <div id="alliancequestion">
        <Header />
            <div class="container">
                <div class="alliancequestion_box">
                    <div class="title">
                        <h1>문의하기</h1>
                        <p>아튜브 웹툰에서 사용된 아트포인트를 충전할 수 있습니다.</p>
                    </div>
                    <div class="contents radio">
                        <p class="left_text">유형선택</p>
                        <div>
                            <input type="radio" class="styled-radio" id="styled-radio-1">
                            <label for="styled-radio-1">제휴문의</label>
                            <input type="radio" class="styled-radio" id="styled-radio-2">
                            <label for="styled-radio-2">광고문의</label>
                        </div>
                    </div>
                    <div class="contents radio">
                        <p class="left_text">분야선택</p>
                        <div>
                            <input type="radio" class="styled-radio" id="styled-radio-3">
                            <label for="styled-radio-3">웹툰</label>
                            <input type="radio" class="styled-radio" id="styled-radio-4">
                            <label for="styled-radio-4">기타 제휴 문의</label>
                        </div>
                    </div>
                    <div class="contents">
                        <p class="left_text">제목</p>
                        <div>
                            <input type="text" placeholder="제목을 입력해주세요" class="i_text">
                        </div>
                    </div>
                    <div class="contents select_box">
                        <p class="left_text">문의유형</p>
                        <div>
                            <select class="on">
                                <option selected disabled hidden style="color:red">문의 유형을 선택하세요</option>
                                <option>제휴/절차 방법</option>
                                <option>콘텐츠 제공 방법</option>
                                <option>연재 문의</option>
                                <option>콘텐츠 사용 방법</option>
                                <option>기타 제휴 문의</option>
                            </select>
                        </div>
                    </div>
                    <div class="contents qa">
                        <p class="left_text">내용</p>
                        <div class="text_box">
                            <b-textarea placeholder="문의 내용을 1000자 이내에서 입력해주세요"></b-textarea>
                            <p class="number"><span>0</span>/1000</p>
                        </div>
                    </div>
                    <div class="contents file">
                        <p class="left_text">파일첨부</p>
                        <div>
                            <div class="file_box">
                                <input type="text" class="file_text">
                                <label for="upload_file" style="border: solid 1px #6d02f8; color: #6d02f8; font-size:16px; text-align:center; padding:12px 0; max-width:124px; width:100%; cursor:pointer">파일 찾기</label>
                                <input type="file" id="upload_file" accept="image/*" required=true style="position:absolute; clip:rect(0, 0, 0, 0);">
                            </div>
                            <p class="ps">파일 첨부는 총 1개 5MB까지 첨부 가능합니다.</p>
                        </div>
                    </div>
                    <div class="contents">
                        <p class="left_text">이메일</p>
                        <div>
                            <input type="text" placeholder="회신받을 이메일을 입력해주세요" class="i_text">
                        </div>
                    </div>
                    <div class="contents">
                        <p class="left_text">문의자명</p>
                        <div>
                            <input type="text" placeholder="문의자명을 입력해주세요" class="i_text">
                        </div>
                    </div>
                    <div class="contents warning">
                        <p class="left_text">유의사항</p>
                        <div>
                            <div class="check_box">
                                <input class="styled-checkbox no" id="styled-checkbox-1" type="checkbox">
                                <label for="styled-checkbox-1">아래 항목에 동의합니다</label>
                            </div>
                            <p>˙아튜브는 제안/문의 처리를 위해 성함과 이메일 주소를 수집하고 있습니다.</p>
                            <p>˙수집된 개인정보는 문의내용 처리와 해결을 위해 사용되며, 전자상거래법에 따라 3년간 보관 후 삭제됩니다.</p>
                            <p>˙개인정보 수집에 대해 거부할 권리가 있으나 동의 거부 시 제휴 문의 접수가 어렵습니다.</p>
                        </div>
                    </div>
                    <div class="button">
                        <router-link tag="a" to="Allianceend">문의 등록하기</router-link>
                        <router-link tag="a" to="/Alliance">문의 취소</router-link>
                    </div>
                </div>
            </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
    },
}
</script>